import { createSlice } from "@reduxjs/toolkit";
import { ISpecialChargeConfig } from "../../typings/interfaces/responses/special-charge-response";
import { getSpecialChargesAction, saveSpecialChargesAction } from "../actions/specialChargeAction";

export interface SpecialChargeState {
    configs: ISpecialChargeConfig[] | null;
    configsLoading: boolean;
    configsError: string | null;
    saveLoading: boolean;
    saveError: string | null;
}

const initialState: SpecialChargeState = {
    configs: null,
    configsLoading: false,
    configsError: null,
    saveLoading: false,
    saveError: null,
};

const specialChargeSlice = createSlice({
    name: "specialCharge",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSpecialChargesAction.pending, (state) => {
                state.configsLoading = true;
                state.configsError = null;
            })
            .addCase(getSpecialChargesAction.fulfilled, (state, action) => {
                state.configsLoading = false;
                state.configs = action.payload.body;
            })
            .addCase(getSpecialChargesAction.rejected, (state, action) => {
                state.configsLoading = false;
                state.configsError = String(action.payload ?? "Something went wrong");
            });

        builder
            .addCase(saveSpecialChargesAction.pending, (state) => {
                state.saveLoading = true;
                state.saveError = null;
            })
            .addCase(saveSpecialChargesAction.fulfilled, (state, action) => {
                state.saveLoading = false;
                state.configs = action.payload.body;
            })
            .addCase(saveSpecialChargesAction.rejected, (state, action) => {
                state.saveLoading = false;
                state.saveError = String(action.payload ?? "Something went wrong");
            });
    },
});

export default specialChargeSlice.reducer;
